module.exports = __webpack_public_path__ + "static/imagen_07-384a6ebbc93b1a2e2725529e6210c18f.jpg";